import "./style.scss";

export function treatments_single_hero_block() {
  const block = document.querySelector(".treatments_single_hero_block");
  if (!block) return;
}
